import { Component } from '@angular/core';
import { FeedbackPlatformSessionNominatorEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Session Nominators') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformsessionnominator-form',
    templateUrl: './feedbackplatformsessionnominator.form.component.html'
})
export class FeedbackPlatformSessionNominatorFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformSessionNominatorEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

